import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { ciIdentify } from '../../config/axios-config';
import logoutIcon from '../../images/icons/logout.svg';
// images and css
import {
  fetchAllInboundApplicationForms,
  fetchApplications,
  fetchInboundFormConversionRates,
} from '../../redux/applications/applicationActions';
import { fetchAllCampaigns, fetchAllCampaignTemplates } from '../../redux/campaigns/campaignActions';
// redux
import { fetchAllLists, fetchListsWithPagination } from '../../redux/lists/listActions';
import { setOnboaringStatus, setOnboaringStep } from '../../redux/onboarding/onboardingActions';
import { fetchAllStageTriggers, fetchStages } from '../../redux/stages/stagesActions';
import {
  checkBetaUserStatus,
  fetchCommissionTiers,
  fetchConnectedEmails,
  fetchDiscountTemplates,
  fetchInboundEmailTemplates,
  fetchMultiBrandAccounts,
  fetchTags,
  fetchTeamMembers,
  fetchUserProfileData,
  fetchUserSetting,
  hideBuyRatnaModal,
  setUserDetails,
  updateDowntimeBanner,
} from '../../redux/user/userActions';
import { getUserInfo } from '../../services/list.service';
// services
import { postSuccessPayment } from '../../services/subscription.service';
// utils
import { getIsUserOnLitePlan, getStorage, isAuthenticated, removeStorage } from '../../utils/auth-utils';
import { capitalizeFirstLetter, getStorageObject, handleLogout } from '../../utils/global';
import BuyRatnaModal from '../common-components/ModalComponent/BuyRatnaModal/BuyRatnaModal';
import Day4StrategySessionModal from '../common-components/ModalComponent/Day4StrategySessionModal';
import HandWryttenModal from '../common-components/ModalComponent/HandWryttenModal';
import InstallExtensionModal from '../common-components/ModalComponent/InstallExtensionModal';
import RatnaReplenishModal from '../common-components/ModalComponent/RatnaReplenishModal';
import ResubscriptionModal from '../common-components/ModalComponent/ResubscriptionModal';
import WhatsNewModal from '../common-components/ModalComponent/WhatsNewModal';
import OnboardingStartModal from '../common-components/OnboardingComponents/OnboardingStartModal';
// components
import AddPaymentMehtod from './Subscription/components/AddPaymentMethod';

import './settings/style.css';
import './styles/_dashboard.scss';

import { fetchInboxUnreadEmailsCount } from '@/redux/inbox/inboxActions';
import { fetchNotifications } from '@/redux/notifications/notificationActions';
import { fetchOnboardingVideos } from '@/redux/onboardingVideos/onboardingVideosActions';
import { setSidebarEffectiveExpanded, setSidebarExpanded } from '@/redux/sidebar/sidebarActions';
import { SET_TEAM_MEMBER_ID } from '@/redux/user/userTypes';
import { updateGoogleAnalyticsEventStatus } from '@/services/user.service';
import { MULTIBRAND_TOKENS_ARRAY } from '@/utils/multibrand-utils';
import { SUBSCRIPTION_STATUS_ENUM } from '@Saral-Influencer-Marketing/saral-utils/src/constants';
import dayjs from 'dayjs';
import { usePostHog } from 'posthog-js/react';

import useQueryParam from '../../hooks/useQueryParam';
import { fetchBlacklistedInfluencer } from '../../redux/blacklist/blacklistActions';
import { fetchChangeLog } from '../../redux/changelog/changelogActions';
import { fetchDashboardTutStatus } from '../../redux/dashboard/dashboardActions';
import {
  fetchInstagramConnectionStatus,
} from '../../redux/socialListening/socialListeningActions';
import { deleteSubscription } from '../../services/payment.service';
import {
  __PROD__,
  CustomContractsForceCollapseRoutes,
  DOWNTIME_BANNER_KEY,
  SocialListeningForceCollapseRoutes,
} from '../../utils/constants';
import PartialActivePartnershipModal from '../common-components/ModalComponent/PartialActivePartnershipModal';
import ResubscriptionPaymentModal from '../common-components/ModalComponent/ResubscriptionPaymentModal';
import DiscountModalContentProvider from '../Modals/DiscountModalContentProvider';
import GenerateTrackingLinkContentProvider from '../Modals/GenerateTrackingLinkContentProvider';
import AccountCancelledModal from './settings/components/wokeCancellation/components/AccountCancelledModal';
import AccountActiveModal from './settings/components/wokeCancellation/modals/AccountActiveModal';
import CancellationModal from './settings/components/wokeCancellation/modals/CancellationModal';
import TrialOverModal from './settings/components/wokeCancellation/modals/TrialOverModal';
import LitePlanModal from './settings/modals/LitePlanModal';
import UserOnPreservationPlanModal from './settings/modals/UserOnPreservationPlanModal';
import Sidebar from './Sidebar';
import SurveyForm from './Subscription/components/Survey/SurveyForm';

export default function Dashboard() {
  // states
  const [showExtensionModal, setShowExtensionModal] = useState(undefined);
  const [whatsNewModalContent, setWhatsNewModalContent] = useState(null);
  const [showReservationModal, setShowReservationModal] = useState(false);
  const [showRatnaReplenishModal, setShowRatnaReplenishModal] = useState(false);
  const [showSurveyForm, setShowSurveyForm] = useState(false);
  const [showResubscriptionModal, setShowResubscriptionModal] = useState(false);
  const [showAccountCancelledModal, setShowAccountCancelledModal] = useState(false);
  const [showResubscriptionPaymentModal, setShowResubscriptionPaymentModal] = useState(false);
  const [showDay4StrategySessionModal, setShowDay4StrategySessionModal] = useState(false);
  const [showSubscriptionCancelledModal, setShowSubscriptionCancelledModal] = useState(false);
  const [showTrialOverModal, setShowTrialOverModal] = useState(false);

  //preservation plan
  const [isUserOnPreservationPlan, setIsUserOnPreservationPlan] = useState(false);
  const [showPreservationPlanModal, setShowPreservationPlanModal] = useState(false);

  // lite plan team lock
  const [showLitePlanTeamMemberLock, setShowLitePlanTeamMemberLock] = useState(false);

  // redux
  const { onboardingStep, isOnboardingShown } = useSelector((state) => state.onboarding);
  const { userDetails, showBuyRatnaModal } = useSelector((state) => state.user);
  const user = useSelector((state) => state.user);

  const [showAccountActiveModal, setShowAccountActiveModal] = useState(false);
  const [partialActivePartnershipModal, setPartialActivePartnershipModal] = useState(false);

  const { list: changelogList } = useSelector((state) => state.changelog);
  // other
  let params = new URLSearchParams(window.location.search);
  const queryParam = useQueryParam();
  const successPaymentSessionId = params.get('session_id');
  const planId = params.get('planId');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const posthog = usePostHog();

  const isPulseRoute = SocialListeningForceCollapseRoutes.some((regex) => regex.test(location.pathname));

  const forceCollapse =
    CustomContractsForceCollapseRoutes.some((regex) => regex.test(location.pathname)) ||
    isPulseRoute ||
    location?.search?.includes('tab=lookalikes') ||
    location?.search?.includes('tab=activation&modal=open') ||
    location?.search?.includes('isCampaignEnabled=true') ||
    (location?.pathname?.includes('/dashboard/get-started') && location.search?.includes('?videoId=')) ||
    (location.pathname?.includes('/dashboard/discovery') && location.search?.includes('?showSearchResults=true')) ||
    (location.pathname?.includes('/dashboard/relationship') && location.search?.includes('?view=table'));

  const { isEffectiveExpanded, isExpanded } = useSelector((state) => state.sidebar);

  useEffect(() => {
    dispatch(setSidebarEffectiveExpanded(forceCollapse ? false : isExpanded));
  }, [forceCollapse, isExpanded]);

  const { applicationCount } = useSelector((state) => state.applications);

  const onExpandChange = (newIsExpanded) => {
    dispatch(setSidebarExpanded(newIsExpanded));
  };

  /**
   * Remove cookies if not logged in
   */
  if (!isAuthenticated) {
    removeStorage('token');
    Cookies.remove('access_token');
  }
  useEffect(() => {
    ciIdentify({
      id: userDetails?._id,
      email: userDetails?.email,
      first_name: capitalizeFirstLetter(userDetails?.first_name),
      last_name: userDetails?.last_name,
      subscription_status: userDetails?.subscriptionStatus,
      is_subscribed: userDetails?.isSubscribed,
      _timestamp: Math.floor(Date.now() / 1000),
    });
  }, []);

  const userOnLitePlan = getIsUserOnLitePlan(userDetails);

  // free tier end status logic
  const showFreeTrialModalStatus =
    !userDetails?.isSubscribed && userDetails?.subscriptionStatus === 'past_due' ? true : false;

  /**
   * function to check and update the GA event
   */
  const triggerGoogleAnalyticsEvent = async () => {
    const response = await updateGoogleAnalyticsEventStatus({ status: true });

    if (response.status) {
      window.dataLayer.push({
        event: 'account_upgraded',
      });
      dispatch(fetchUserInfo());
    }
  };

  /**
   * function to fetch user details
   */
  const fetchUserInfo = async (isFirstTime = false) => {
    let body = {};
    if (isFirstTime) body = { isFirstRequest: 'isFirstRequest' };
    const response = await getUserInfo(body); // api call

    if (response?.status) {
      // identify user in posthog
      if (__PROD__) {
        posthog.identify(response.data._id, {
          email: response.data?.primaryEmail,
          userEmail: response.data?.email,
          name: `${response.data.first_name} ${response.data.last_name}`,
          userId: response.data._id,
        });
      }
      dispatch(setUserDetails(response.data));
      dispatch(setOnboaringStatus(response.data.isOnboardingShown));
      dispatch({
        type: SET_TEAM_MEMBER_ID,
        payload: response.data?.onlyMyViewId,
      });
      if (response?.data?.isSurveyFormFilled === false) {
        setShowSurveyForm(true);
      }

      if (!response?.data?.isPrimaryMember && response?.data?.plan?.name.includes('lite')) {
        setShowLitePlanTeamMemberLock('team');
        setIsUserOnPreservationPlan(true);
      }

      const v1FreeUser =
        response?.data?.subscriptionStatus === 'free' && response?.data?.isPaymentMethodAdded === false;

      if (response.data?.subscriptionStatus === 'preserve') {
        navigate('relationship');
        setShowPreservationPlanModal(true);
        setIsUserOnPreservationPlan(true);
      }
      // Now making all v1 free users to have to message support for reactivation
      else if (response?.data?.subscriptionStatus === 'cancelled' && !response?.data?.isSubscribed) {
        setShowAccountCancelledModal(true);
      } else if (response?.data?.isSubscriptionEnded) {
        if (response?.data?.subscriptionStatus === 'pause') {
          setShowResubscriptionModal(true);
        } else {
          setShowResubscriptionPaymentModal(true);
        }
      }
      // check is onboarding is shown or not
      if (!response.data.isOnboardingShown) {
        dispatch(setOnboaringStep(0));
        document.querySelector('.root-overlay-container').style.display = 'block'; // showing onboarding overlay
      }
      if (response.data?.showFreeCreditModal?.show) {
        setShowRatnaReplenishModal(true);
      }

      if (response.data.showStrategySession && !response.data.isStrategySessionBooked) {
        setShowDay4StrategySessionModal(true);
      }

      if (!response?.data?.isGoogleAnalyticsEventRecorded && response?.data?.upgradedAt) {
        triggerGoogleAnalyticsEvent();
      }
    }
  };

  // isSubscribed =false
  // subscriptionStatus = "cancelled"
  // show Resubscription Modal logic if someone deletes it from DOM
  const [reloadKey, setReloadKey] = useState(0);
  useEffect(() => {
    if (
      (!userDetails?.isSubscribed && ['cancelled', 'pause'].includes(userDetails?.subscriptionStatus)) ||
      (!userDetails?.isSubscribed && userDetails?.subscriptionStatus === 'past_due') ||
      !userDetails?.isPaymentMethodAdded
    ) {
      setReloadKey((prevKey) => prevKey + 1);
    }

    if (queryParam.get('next') === 'onboarding') {
      queryParam.delete('next');
      fetchUserInfo();
    }
  }, [location.pathname]);

  /**
   * function to check extention status
   */
  const checkExtensionModalStatus = () => {
    const isExtensionModalShown = getStorage('isExtensionModalShown');
    if (isExtensionModalShown) {
      setShowExtensionModal(false);
    } else {
      setShowExtensionModal(true);
    }
  };

  const checkPartnershipLimitModal = () => {
    if (userDetails?.accountVersion === 'v1') {
      return;
    }
    const unblockTimeStamp = localStorage.getItem('partnership-modal-delay');
    const unblockDate = unblockTimeStamp ? dayjs(unblockTimeStamp) : null;
    const totalActivePartnerships = userDetails?.totalActivePartnerships || 0;
    const totalAllowedPartnerships = userDetails?.featureLimit?.activePartnerships || 100;
    const limitReachedPercentage = (totalActivePartnerships / totalAllowedPartnerships) * 100;
    if (limitReachedPercentage >= 90) {
      if (!unblockDate) {
        setPartialActivePartnershipModal(true);
      } else if (unblockDate.isValid() && Math.abs(unblockDate.diff(new Date(), 'day')) < 1) {
        localStorage.setItem('partnership-modal-delay', null);
        setPartialActivePartnershipModal(true);
      }
    }
  };

  const checkIfTrialOver = () => {
    if (userDetails?.accountVersion === 'v1') {
      return;
    }

    if (
      new Date() > dayjs(userDetails?.freeTrialEnd * 1000).toDate() &&
      (userDetails?.subscriptionStatus === SUBSCRIPTION_STATUS_ENUM.trial ||
        userDetails?.subscriptionStatus === SUBSCRIPTION_STATUS_ENUM.trial_ended)
    ) {
      setShowTrialOverModal(true);
    }
  };

  const checkForAccountActive = () => {
    if (userDetails?.accountVersion === 'v1') {
      return;
    }

    if (userDetails?.postActiveWelcomeModal) {
      setShowAccountActiveModal(true);
    }
  };

  /**
   * function to check whats new modal status
   */
  const checkWhatsNewModalStatus = () => {
    let currentVersion = getStorage('weekly-banner-version');
    let latestVersion = currentVersion;
    let whatsNewLogs = [];
    changelogList.forEach((log) => {
      if (!log?.isActive) return;
      if (!currentVersion || log.version > currentVersion) {
        latestVersion = log.version;
        whatsNewLogs.push(log);
      }
    });
    if (whatsNewLogs.length) {
      setWhatsNewModalContent({ latestVersion, list: whatsNewLogs });
    }
  };

  const handleSubscriptionCancellation = async () => {
    try {
      const response = await deleteSubscription();
      if (response?.status) {
        setShowResubscriptionModal(false);
        setShowSubscriptionCancelledModal(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    checkWhatsNewModalStatus();
  }, [changelogList]);

  useEffect(() => {
    checkExtensionModalStatus();
    fetchUserInfo(true);

    // redux calls
    dispatch(fetchStages());
    dispatch(fetchDashboardTutStatus());
    dispatch(fetchAllCampaigns());
    dispatch(checkBetaUserStatus());
    dispatch(fetchUserProfileData());
    dispatch(fetchDiscountTemplates());
    dispatch(fetchTeamMembers());
    dispatch(fetchConnectedEmails());
    dispatch(fetchTags());
    dispatch(fetchApplications({ approvalStatus: 'pending' }));
    dispatch(fetchUserSetting());
    dispatch(fetchCommissionTiers());
    dispatch(fetchInboundEmailTemplates());
    dispatch(fetchNotifications(null, 'firstLoad'));
    dispatch(fetchChangeLog());
    dispatch(fetchBlacklistedInfluencer());
    dispatch(fetchInstagramConnectionStatus());
    dispatch(updateDowntimeBanner(Boolean(getStorageObject(DOWNTIME_BANNER_KEY)?.isDowntimeBannerDismissed)));
    dispatch(fetchListsWithPagination({ listType: 'active' }));
    dispatch(fetchAllLists());
    dispatch(fetchAllStageTriggers());
    dispatch(fetchAllCampaignTemplates());
    dispatch(fetchAllInboundApplicationForms());
    dispatch(fetchInboundFormConversionRates([]));
    dispatch(fetchMultiBrandAccounts(MULTIBRAND_TOKENS_ARRAY));
    dispatch(fetchInboxUnreadEmailsCount());
    dispatch(fetchOnboardingVideos());
  }, []);

  // check for onboarding modal status and  show overlay accordingly
  useEffect(() => {
    if (Object.keys(userDetails) > 0 && !userDetails.isOnboardingShown) {
      document.querySelector('.root-overlay-container').style.display = 'block';
    }
    checkIfTrialOver();
    checkForAccountActive();
    checkPartnershipLimitModal();
  }, [userDetails]);

  useEffect(() => {
    const successSubsciption = async (successPaymentSessionId, planId) => {
      const data = await postSuccessPayment(successPaymentSessionId, planId);
      if (data.success) {
        window.location.href = `${import.meta.env.REACT_APP_DOMAIN}/dashboard`;
      }
    };
    if (successPaymentSessionId && planId) {
      successSubsciption(successPaymentSessionId, planId);
    }
  }, [planId, successPaymentSessionId]);

  /**
   * function to show all the modals
   */
  const showModal = () => {
    return userDetails?.isPaymentMethodAdded ? (
      <>
        {showTrialOverModal ? (
          <TrialOverModal show={showTrialOverModal} />
        ) : showResubscriptionPaymentModal ? (
          <ResubscriptionPaymentModal
            show={showResubscriptionPaymentModal}
            onClose={() => setShowResubscriptionPaymentModal(false)}
            onPaymentSuccess={() => {
              window.location.reload();
            }}
          />
        ) : (
          <></>
        )}
        <AccountActiveModal show={showAccountActiveModal} setShow={setShowAccountActiveModal} />
        <PartialActivePartnershipModal
          show={partialActivePartnershipModal}
          setShow={setPartialActivePartnershipModal}
        />
        <SurveyForm
          show={showSurveyForm}
          onClose={(refetch = true) => {
            setShowSurveyForm(false);
            document.querySelector('.root-overlay-container').style.display = 'none';
            if (refetch) {
              fetchUserInfo();
            }
          }}
        />
        <InstallExtensionModal
          show={
            !showReservationModal &&
            userDetails?.isSurveyFormFilled &&
            showExtensionModal &&
            userDetails.isOnboardingShown
          }
          handleClose={() => setShowExtensionModal(false)}
        />
        <WhatsNewModal
          whatsNewModalContent={whatsNewModalContent}
          show={
            !showReservationModal &&
            userDetails?.isSurveyFormFilled &&
            Boolean(whatsNewModalContent) &&
            !showExtensionModal &&
            userDetails.isOnboardingShown
          }
          handleClose={() => setWhatsNewModalContent(null)}></WhatsNewModal>

        <OnboardingStartModal
          show={!showReservationModal && userDetails?.isSurveyFormFilled && !isOnboardingShown && onboardingStep === 0}
        />
        <AccountCancelledModal show={showAccountCancelledModal} />
        <BuyRatnaModal show={showBuyRatnaModal} handleClose={() => dispatch(hideBuyRatnaModal())} />

        <RatnaReplenishModal
          show={showRatnaReplenishModal && !showFreeTrialModalStatus && userDetails?.isSubscribed}
          handleClose={() => setShowRatnaReplenishModal(false)}
        />

        <ResubscriptionModal
          show={showResubscriptionModal}
          handleClose={() => setShowResubscriptionModal(false)}
          handleSubscriptionCancellation={handleSubscriptionCancellation}
          handleLogout={handleLogout}
        />

        <CancellationModal show={showSubscriptionCancelledModal} />
        <HandWryttenModal />

        <Day4StrategySessionModal
          show={showDay4StrategySessionModal}
          handleClose={() => setShowDay4StrategySessionModal(false)}
        />
      </>
    ) : userDetails?.subscriptionStatus === 'cancelled' ? (
      <AccountCancelledModal show={true} />
    ) : (
      <AddPaymentMehtod />
    );
  };

  // JSX for dashboard
  return (
    <DiscountModalContentProvider>
      <GenerateTrackingLinkContentProvider>
        <div className="dashboard-main" key={reloadKey}>
          {/* Logout Button while supscription modal */}
          {Object.hasOwn(userDetails, 'isPaymentMethodAdded') && !userDetails?.isPaymentMethodAdded && (
            <button className="subscription-modal-logout-button" onClick={handleLogout}>
              <img src={logoutIcon} alt="logout icon" />
              Logout
            </button>
          )}

          <div className="dashboard-row">
            <Sidebar
              isOnboardingShown={isOnboardingShown}
              onboardingStep={onboardingStep}
              userDetails={userDetails}
              applicationCount={applicationCount}
              isUserOnPreservationPlan={isUserOnPreservationPlan}
              userOnLitePlan={userOnLitePlan}
              forceCollapse={forceCollapse}
              disableHoverExpand={isPulseRoute}
              onExpandChange={onExpandChange}
            />

            <div
              style={{
                overflow: 'auto',
                position: 'relative',
                zIndex: (showPreservationPlanModal || showLitePlanTeamMemberLock) && '1',
                maxHeight:
                  (location?.search?.includes('tab=activation&modal=open') ||
                    location?.pathname?.includes('custom-contracts')) &&
                  '100vh',
              }}
              className={`dashboard-feature-div ${!isEffectiveExpanded ? 'sidebar-collapsed' : ''}`}>
              <UserOnPreservationPlanModal show={showPreservationPlanModal} handleCancel={handleLogout} />
              <LitePlanModal
                show={showLitePlanTeamMemberLock}
                setShow={setShowLitePlanTeamMemberLock}
                teamLock
                onClose={() => {
                  handleLogout();
                }}
              />
              <Outlet />
            </div>

            {/* Global Modals */}
            {userDetails?._id && showModal()}
          </div>
        </div>
      </GenerateTrackingLinkContentProvider>
    </DiscountModalContentProvider>
  );
}
